import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from './ui/Modal';
import './Vault.css';

/**
 * Cold start's conflict screen — multi-device sync Part B
 * (app/plans/01_08_2026/vault-multidevice/PLAN.md §3, §4 row S4, §7).
 *
 * Shown when this device holds live, unsynced secrets under a different
 * vault than the signed-in account's own — adopting would silently orphan
 * every local item, permanently (every AAD would change). States that
 * plainly and offers the export/import escape hatch; no in-app merge action
 * (matching VSC §16 O2's existing "not built" stance).
 */
export default function VaultColdStartConflictScreen({ isOpen, onClose }) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      title={t('vault.coldStartConflictTitle', 'This device has a different vault')}
    >
      <div className="vault-pass-body">
        <div className="vault-passkey-danger">
          <div className="vault-passkey-danger-title">
            {t('vault.coldStartConflictHeadline', 'Unsynced secrets would be lost')}
          </div>
          <div className="vault-passkey-danger-text">
            {t(
              'vault.coldStartConflictBody',
              "This device already holds passwords or other secrets under a different, unsynced vault than the one this account uses on your other devices. Bringing that account's vault to this device now would make those local secrets permanently unreadable — every one of them is encrypted specifically for the vault they're already in."
            )}
          </div>
        </div>
        <p className="vault-pass-text">
          {t(
            'vault.coldStartConflictEscapeHatch',
            "To keep both: export this device's items first (Vault → Backup), then re-import them once this device is on the account's own vault. There is no automatic way to merge the two."
          )}
        </p>
        <div className="modal-footer-row">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm"
          >
            {t('common.close', 'Close')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
